import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  TemplateRef,
  ViewEncapsulation,
  OnChanges,
  SimpleChanges,
  inject,
  OnInit,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  NgbModal,
  NgbModalConfig,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";
import { MyIcon } from "@shared/classes/my-icon";
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";

import { ButtonDirective } from "@shared/directives/button.directive";
@Component({
  selector: "app-query-error-alert",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./query-error-alert.component.html",
  styleUrls: ["./query-error-alert.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [ButtonDirective, CommonModule, NgbModule, FontAwesomeModule, TranslateModule],
})
export class QueryErrorAlertComponent implements OnChanges, OnInit {
  modal!: NgbModalRef;
  @ViewChild("alertModal", { static: false })
  alertModal!: TemplateRef<unknown>;
  icon: MyIcon = new MyIcon();
  @Input() isActive: boolean = false;
  @Input() message: string = "Fallo de conexion";

  private readonly router: Router = inject(Router);
  private readonly modalService: NgbModal = inject(NgbModal);
  private readonly modalConfig: NgbModalConfig = inject(NgbModalConfig);

  private configureModal(): void {
    this.modalConfig.backdrop = "static";
    this.modalConfig.keyboard = false;
  }

  openModal(content: TemplateRef<unknown>): void {
    this.modal = this.modalService.open(content, {
      ariaLabelledBy: "modal-basic-title",
      windowClass: "dark-modal",
      size: "sm",
    });
  }

  closeModal(): void {
    if (this.modal) {
      this.modal.close();
    }
  }

  reloadPage(): void {
    document.location.reload();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isActive"]) {
      if (this.isActive) {
        this.openModal(this.alertModal);
      } else {
        this.closeModal();
      }
    }
  }

  closeModalByPath(): void {
    const routeSubscription: Subscription = this.router.events.subscribe((event) => {
      // Verifica si el evento de navegación es una instancia de NavigationEnd
      if (event instanceof NavigationEnd) {
        routeSubscription.unsubscribe();
        this.closeModal();
      }
    });
  }
 
  ngOnInit(): void {
    this.configureModal();
    this.closeModalByPath();
  }


}
